import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import useStyles from "./styles";
import { DPButton, DPPermissionGate } from "Components/DP";
import mergeClasses from "classnames";
import {
  ManagerStatus,
  accessLevelDictionary,
} from "Shared/types/Admins";
import { EmployerPermissions, ProviderLocation } from "generated/graphql";
import { LocationsTableCell } from "Components/Shared/LocationsTableCell/LocationsTableCell";

type AdminTableRowProps = {
  fullName: string;
  status: string;
  permissions: EmployerPermissions;
  payGroup: string;
  email: string;
  ether: boolean;
  locations: ProviderLocation[];
  handleClick: () => void;
};

const AdminTableRow = ({
  fullName,
  status,
  permissions,
  payGroup,
  email,
  ether,
  locations,
  handleClick,
}: AdminTableRowProps) => {
  const classes = useStyles({ status });

  return (
    <TableRow className={classes.text}>
      <TableCell>{fullName}</TableCell>
      <TableCell className={classes.longText}>{email}</TableCell>
      <TableCell className={classes.title}>{payGroup}</TableCell>
      <LocationsTableCell locations={locations} />
      <TableCell>{`${accessLevelDictionary[permissions]}${
        ether ? " - cannot modify" : ""
      }`}</TableCell>
      <TableCell
        className={mergeClasses(
          classes.status,
          classes.title,
          classes.statusCell
        )}
      >
        {status}
      </TableCell>
      <DPPermissionGate permissionKeys={["canUpdateAdminStatus"]}>
        <TableCell>
          {
            status.toLowerCase() === ManagerStatus["ACTIVE"].toLowerCase() &&
            !ether && (
              <DPButton onClick={handleClick} color="default">
                Deactivate
              </DPButton>
            )
          }
        </TableCell>
      </DPPermissionGate>
    </TableRow>
  );
};

export default AdminTableRow;
